import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import * as Yup from "yup";
import { deleteDocument, submitEducationDetailsforPanel, submitEnclosureFiles } from "../../auth/services/privateapicalling";
import { set } from "lodash";
import { previousDay } from "date-fns";
import { toast,ToastContainer } from "react-toastify";

interface EducationProps {
  onNext: (data: any) => void;
  onPrev: () => void;
  existData: any;
  onAdd:()=>void;
  isEducationFilled:boolean
  fetchApplicationExistenceCheck:()=>void
}

type Structural = {
  isStructureEngineer: "yes" | "no" | "";
  structureDetail: File | null;
};
const Education: React.FC<EducationProps> = ({ onNext, onPrev , existData ,onAdd , isEducationFilled,fetchApplicationExistenceCheck}) => {


    const userdetails = useSelector((state: any) => state.auth.userDetails);
   

  const fileInputRef = useRef<HTMLInputElement>(null);
  const token = useSelector((state: any) => state.auth.token);
  const [fileKey, setFileKey] = useState(Date.now());
 const language = useSelector((state:any)=>state.auth.language);
   const formLanguage = useSelector((state: any) => state.auth.formLanguage)


  const [qualification , setQualification] = useState<string>("");
  const [specialization , setSpecialization] = useState<string>("");

  const [file , setFile] = useState< File | null >(null);
   
  const [educationList, setEducationList] = useState<{ education: string;  specialization: string ; proof: File | null }[]>([]);
  const [newEducation, setNewEducation] = useState<any[]>([]);
  const [errors, setErrors] = useState<{ education?: string; proof?: string; specialization?: string;otherSpec?:string; listError?: string }>({});
    const [isLoading, setIsLoading] = useState(false);
    const [submitting, setSubmitting] = useState(false)
    const [isStructLoading, setIsStructLoading] = useState(false);
    const [structureData,setStructureData] = useState({})
    const [fieldDisable,setFieldDisable] = useState(true);
    const [isNextLoading, setIsNextLoading] = useState(false);
    const [formData, setFormData] = useState<Structural>({
      isStructureEngineer: existData?.isStructuralEngineer? existData?.isStructuralEngineer : "no",
      structureDetail: null,
    });
    const [errorrs, setErrorrs] = useState<{
      isStructureEngineer?: string;
      structureDetail?: string;
    }>({});
    const [isStructUploaded, setIsStructUploaded] = useState<boolean>(true);
   
    const [structureDetailField,setStructureDetailField] = useState(existData?.isStructuralEngineer? existData?.isStructuralEngineer : "no")
    
  const educationLevelMap = {
    highSchool: 'High School ',
    diploma: 'Diploma ',
    bachelorDegree: 'Bachelor Degree ',
    mastersDegree: 'Masters Degree ',
    phd: 'Ph.D.',
  };
  const professionMap = {
    civilEngineer: ' Civil Engineer',
    architect: ' Architect',
    constructionEngineer: 'Construction Engineer',
    billingServiceEngineer: 'Billing Service Engineer',
  };
  const validationSchema = Yup.object({
    education: Yup.string().required("Education qualification is required"),
    specialization: Yup.string().when(["education"], ([education], schema) => {
      if (education && education !== "highSchool") {
        return schema.required("Specialization is required");
      }
      return schema.notRequired();
    }),
    otherSpec: Yup.string().when('specialization', {
      is: 'other',
      then: schema => schema.required('Other specialization is required'),
      otherwise: schema => schema.notRequired()
    }),
    proof: Yup.mixed()
    .required("Attested copy is required.")
    .test("fileFormat", "Only PDF, JPG, and JPEG files are allowed.", (value) => {
      if (!value || !(value instanceof File)) return false;
      const allowedFormats = ["application/pdf", "image/jpeg", "image/jpg"];
      return allowedFormats.includes(value.type);
    })
    .test("fileSizeMax", "File size must be less than 3MB.", (value) => {
      if (!value || !(value instanceof File)) return false;
      return value.size <= 3 * 1024 * 1024; // 3 MB
    })
    .test("fileSizeMin", "File size must be at least 40KB.", (value) => {
      if (!value || !(value instanceof File)) return false;
      return value.size >= 40 * 1024; // 50 KB
    }),
  
  });
  const [otherSpec,setOtherSpec]  = useState("")
  const validationSchemaStruct = Yup.object({
    isStructureEngineer: Yup.string()
      .required("Please select whether you are a structural engineer")
      .oneOf(["yes", "no"], "Invalid selection"),
  
    structureDetail: Yup.mixed().test(
      "structureDetailConditional",
      "Attested copy is required and must be a PDF, JPG, or JPEG between 100KB and 3MB.",
      function (value) {
        const { isStructureEngineer } = this.parent;
  
        if (isStructureEngineer !== "yes") {
          return true; // Not required
        }
  
        if (!value || !(value instanceof File)) {
          return this.createError({
            message: "Attested copy is required.",
          });
        }
  
        const allowedTypes = ["application/pdf", "image/jpeg", "image/jpg"];
        if (!allowedTypes.includes(value.type)) {
          return this.createError({
            message: "Only PDF, JPG, and JPEG files are allowed.",
          });
        }
  
        if (value.size > 3 * 1024 * 1024) {
          return this.createError({
            message: "File size must be less than 3MB.",
          });
        }
  
        if (value.size < 40 * 1024) {
          return this.createError({
            message: "File size must be at least 40KB.",
          });
        }
  
        return true;
      }
    ),
  });


const validateFormStruct = async (fileToValidate?: File | null) => {
  try {
    await validationSchemaStruct.validate(
      {
        isStructureEngineer: formData.isStructureEngineer,
        structureDetail: fileToValidate || formData.structureDetail,
      },
      { abortEarly: false }
    );

    setErrorrs({});
    return true;
  } catch (err) {
    if (err instanceof Yup.ValidationError) {
      const newErrors: { isStructureEngineer?: string; structureDetail?: string } = {};
      err.inner.forEach((error) => {
        if (error.path) {
          newErrors[error.path as keyof typeof newErrors] = error.message;
        }
      });
      setErrorrs(newErrors);
    }
    
    // If "no" is selected, no file is required
    if (structureDetailField === "no") {
      return true;
    }
    
    // If "yes" is selected and document already exists, allow submission
    if (
      structureDetailField === "yes" && 
      existData && 
      existData.docs?.find((doc: any) => doc.documentName === "structureErrDoc")
    ) {
      return true;
    }
    
    return false;
  }
};
  const [isStructuralEngineer, setIsStructuralEngineer] = useState(
    existData?.isStructuralEngineer ?? "no"
  );
  

  const handleInputChange = (e: React.ChangeEvent<HTMLSelectElement | HTMLInputElement>) => {
    const { name, value } = e.target;
  
  
    if (name === "proof") {
      const fileInput = e.target as HTMLInputElement;
      const selectedFile = fileInput.files?.[0];
  
      if (selectedFile) {
        setFile(selectedFile);
        setErrors((prev) => ({ ...prev, proof: "" })); // Clear error when a file is selected
      }
    }else if(name === "specialization" ) {
      // setFieldDisable(false)
     
      setSpecialization(value);
      setErrors((prev) => ({ ...prev, specialization: "" }));
    
    }
    else if( name === "otherSpec"){
     
      setOtherSpec(value)
      setErrors((prev) => ({ ...prev, specialization: "" }));
    }
    
    else {
      setFieldDisable(false)
      setQualification(value);
      setErrors((prev) => ({ ...prev, education: "" })); // Clear education error
    }
  };
  

  // Validate form inputs using Yup
  const validateForm = async () => {
    try {
      
      await validationSchema.validate({ education: qualification,specialization:specialization, proof: file, otherSpec:otherSpec }, { abortEarly: false });
      setErrors({});
      return true;
    } catch (err) {
      if (err instanceof Yup.ValidationError) {
        const newErrors: { education?: string; proof?: string } = {};
        err.inner.forEach((error) => {
      

          if (error.path) newErrors[error.path as keyof typeof newErrors] = error.message;
        });
        setErrors(newErrors);
      }
      return false;
    }
  };
 
  
  // Ensure at least one entry exists before proceeding
  const handleSubmit = async (updatedEducation:any[]) => {

    const data = {
      eduQualification:updatedEducation,
      applicationId:existData.applicationId
    }   

      const submitEdu = await submitEducationDetailsforPanel(data , token  );
      

      if(submitEdu.success==true)
        {
  
            setQualification("");
            
            fetchApplicationExistenceCheck()
            // fetchApplicationExistenceCheck()
          
        }
        else{
          // alert(`${submitEdu.message}`)
          toast.error(`${submitEdu.message}`, { position: "top-right", autoClose: 3000,});
        }

   
  };

  // Add an education entry
  const addEducation = async () => {
   
  
  setIsLoading(true);

    const isValid = await validateForm();  
   

    if (isValid) {
      
      const formDataa = new FormData();
      const existingDoc = existData && existData.docs?.find((doc: any) => doc.documentName === qualification);
    
      formDataa.append("file", file as Blob);
      formDataa.append("documentName", qualification);
      formDataa.append("applicationId", existData.applicationId);
    
      const uploadEduDoc = await submitEnclosureFiles(formDataa , token , existingDoc?.id);
      setIsLoading(false);
      if(uploadEduDoc.success==true)
      { toast.success(uploadEduDoc?.message,{ position: "top-right", autoClose: 3000,})
        const educationData = {
          docId:uploadEduDoc.data?.id,
          documentName:uploadEduDoc.data?.documentName,
          fileName:uploadEduDoc.data?.fileName,
          standard:qualification,
          // specialization:specialization 
          specialization:specialization == "other" ? otherSpec : specialization
        }
  
   
        setNewEducation((prev) => {
          const isDocIndex = prev.findIndex((edu: any) => edu.documentName === educationData.documentName);
          let updatedEducation = [...prev];
          
         
          if (isDocIndex !== -1) {
            // Case 2: If found, update the existing document
            updatedEducation[isDocIndex] = { ...updatedEducation[isDocIndex], ...educationData,
              isStructuralEngineer:formData.isStructureEngineer,structuralDetail:formData.structureDetail };
          }
        
          // Case 1 & 3: If the new document is different (ensuring no duplicate addition)
          const isNewDocument = !prev.some((edu: any) => edu.docId === educationData.docId);
          
          if (isNewDocument) {
            updatedEducation.push({ ...educationData });
          }
           handleSubmit(updatedEducation);
           setSpecialization("")
           setFieldDisable(true)
           setFileKey(Date.now())
         
          
          return updatedEducation;

        });
        // onAdd();
      }
    
      //   onNext(educationList)
      
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
      
     
    }
    setIsLoading(false);
  };
 const handleInputStructuredetail = (e: React.ChangeEvent<HTMLSelectElement | HTMLInputElement>) => {
  const { name, type } = e.target;
  
  if (type === "file") {
    const file = (e.target as HTMLInputElement).files?.[0] || null;

    setFormData((prev) => ({
      ...prev,
      structureDetail: file,
    }));
    
    // Pass the file directly to the upload function
    handleUploadStructureErrdoc(file);
  } else {
    const value = e.target.value;
    
    if (value === "yes") {
      setIsStructUploaded(false);
    } else {
      setIsStructUploaded(true);
    }

    setStructureDetailField(value);
    setIsStructuralEngineer(value);
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  }
};
  const handleUploadStructureErrdoc = async (file?: File | null) => {
  setIsStructLoading(true);
  
  // Use the passed file if available, otherwise use formData
  const fileToUpload = file || formData.structureDetail;
  
  const isValid = await validateFormStruct(fileToUpload); 

  if (isValid) {
    const formDataa = new FormData();
    const existingDoc = existData && existData.docs?.find((doc: any) => doc.documentName === "structureErrDoc");
    
    formDataa.append("file", fileToUpload as Blob);
    formDataa.append("documentName", "structureErrDoc");
    formDataa.append("applicationId", existData.applicationId);
    
    const uploadEduDoc = await submitEnclosureFiles(formDataa, token, existingDoc?.id);
    
    if (uploadEduDoc.success === true) {
      toast.success(uploadEduDoc?.message, { 
        position: "top-right", 
        autoClose: 3000 
      });
      setIsStructUploaded(true);
      fetchApplicationExistenceCheck();
    }
  }
  
  setIsStructLoading(false); 
};
  const toastCooldown = useRef(false);

  const showErrorToast = (message: string) => {
    if (toastCooldown.current) return; // Skip if still in cooldown
  
    toast.error(message, { position: "top-right", autoClose: 3000 });
    toastCooldown.current = true;
  
    // Reset cooldown after 3 seconds
    setTimeout(() => {
      toastCooldown.current = false;
    }, 3000);
  };

  const handleNext = async () => {  
    
    if (newEducation.length === 0) {
      setErrors((prev) => ({
        ...prev,
        listError: "At least one education entry is required",
      }));
     
      return;

    }

    setIsNextLoading(true);
    const isValid = await validateFormStruct(); 
    const isUploadedStruEng = isStructUploaded;
  
    if(!(isValid && isUploadedStruEng)){
      setIsNextLoading(false);
      if(!isUploadedStruEng)
        
        showErrorToast("Please Upload Structure Engineer Document");
        
      return;
    }
    else{
    
      const data ={   
        isStructuralEngineer:formData.isStructureEngineer, 
        applicationId:existData.applicationId,
        eduQualification:existData.eduQualification,
        structuralDetail : {
            docId:existData && existData.docs?.find((doc: any) => doc.documentName === "structureErrDoc")?.id,
            documentName:existData && existData.docs?.find((doc: any) => doc.documentName === "structureErrDoc")?.documentName,
            fileName:existData && existData.docs?.find((doc: any) => doc.documentName === "structureErrDoc")?.fileName,
          }}
          const submitEdu = await submitEducationDetailsforPanel(data , token  );
        fetchApplicationExistenceCheck()
          setIsNextLoading(false);
      onNext(""); 
    }

  }


  // Delete an education entry
  const deleteEducation = async (edu: any) => {
  
 
    const body = {
      docId: edu.docId,
      applicationId: existData.applicationId,
      fieldName: "eduQualification",
    }
   
    try {
      const res = await deleteDocument(body, token);
      if(res.success==true)
      {
        const updatedEducation = newEducation.filter((item: any) => item.docId !== edu.docId);
        setNewEducation(updatedEducation);
        setEducationList(updatedEducation);
        setFileKey(Date.now());
        fetchApplicationExistenceCheck()
        // fetchApplicationExistenceCheck()
     
      }
      
      
    } catch (error) {
      // alert("Error deleting education entry:");
      toast.error(`Error deleting education entry: ${error}`, { position: "top-right", autoClose: 3000,});
      
    }
  };


  useEffect(()=>{
    //.log('application iddd',applicationIdRedux)
    //.log('userDetail', userdetails)
    const eduQualification = existData?.eduQualification || [];
    //.log('eduqqqq',eduQualification)

    // const eduData = existData?.eduQualification.map((edu: any) =>
    //   edu[0] ? edu[0] : edu // If data is nested inside an index, extract it
    // );
    const eduData = Array.isArray(existData?.eduQualification) && existData?.eduQualification.length > 0 
  ? existData.eduQualification.map((edu: any) => (edu[0] ? edu[0] : edu))
  : [];
    //.log('existData',existData)
    setNewEducation(eduData);

  },[existData])

  useEffect(() => { 
    //.log('newww edd',newEducation)
    //.log('existData',existData)
    if (newEducation.length > 0) {
      setEducationList(newEducation);
    }
  }, [newEducation]);

  return (
    <div className="row">
      <div className="">
        <div className="card">
          <div className="card-header">
            <h6 className="card-title">{language.enter_details}</h6>
          </div>

          {/* Display Education List Table */}
          { Array.isArray(newEducation) && newEducation.length > 0 && (
            <div className="table-responsive">
              <h4 className="text-info mt-2 ms-4">{language.education_details}:</h4>
              <table className="table table-bordered mt-3">
                <thead className="table-light">
                  <tr>
                    <th>Sr No</th>
                    <th>{language.education}</th>
                    <th>Specialization</th>
                    <th>{language.attachements}</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {newEducation.map((edu:any, index:any) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{edu.standard ? educationLevelMap[edu.standard] : "NA"}</td>
                      <td>
                        {edu.specialization ? (edu.specialization === "other" ? edu.otherSpec : professionMap[edu.specialization]) : "NA"}</td>
                      <td>
                        {/* <a href={URL.createObjectURL(edu?.proof!)} target="_blank" rel="noopener noreferrer">
                          {edu?.proof?.name}
                        </a> */}
                        {edu?.fileName}
                      </td>
                      <td>
                        <button className="btn btn-danger btn-sm" onClick={() => deleteEducation(edu)}>🗑 {language.delete}</button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          <div className="card-body">
            <form>
              <h4 className="text-info mb-3">{language.fill_education}:</h4>

              {/* Education Qualification Dropdown */}
              <div className="align-items-center mb-4">
                <div className="col-md-8 mb-3">
                  <label className="form-label">{formLanguage.education} ({language.education}) <span className="text-danger">*</span></label>
                  <select className="form-control" name="education" value={qualification} onChange={handleInputChange}>
                    <option value="">{formLanguage.sel_qual} ({language.sel_qual})</option>
                    <option value="highSchool">{formLanguage.hs} ({language.hs})</option>
                    <option value="diploma">{formLanguage.diploma} ({language.diploma})</option>
                    <option value="bachelorDegree">{formLanguage.bd} ({language.bd})</option>
                    <option value="mastersDegree">{formLanguage.md} ({language.md})</option>
                    <option value="phd">{formLanguage.phd} ({language.phd})</option>
                  </select>
                  {errors.education && <p className="text-danger">{errors.education}</p>}
                </div>
                {qualification !== "highSchool" && (
                  <div className="col-md-8 mb-3">
                    <label className="form-label">
                      વિશેષતા ({language.specialization}) 
                    </label>
                    <select
                      className="form-control"
                      name="specialization"
                      value={specialization}
                      onChange={handleInputChange}
                    >
                      <option value="" disabled>-- Select Specialization --</option>
                      <option value="civilEngineer">સિવિલ એન્જિનિયર (Civil Engineer)</option>
                      <option value="architect">આર્કિટેક્ટ (Architect)</option>
                      <option value="constructionEngineer">બાંધકામ ઈજનેર (Construction Engineer)</option>
                      <option value="billingServiceEngineer">બિલ્ડિંગ સર્વિસ એન્જિનિયર (Building Service Engineer)</option>
                      <option value="other">અન્ય (Other)</option>
                    </select>
                    {errors.specialization && <p className="text-danger">{errors.specialization}</p>}

                    {/* Show this input when "other" is selected */}
                    {specialization === "other" && (
                      <div className="mt-2">
                        <label className="form-label">અન્ય વિશેષતા દાખલ કરો (Enter Other Specialization)</label>
                        <input
                          type="text"
                          className="form-control"
                          name="otherSpec"
                          // value={otherSpecialization}
                          maxLength={30}
                          onChange={handleInputChange}
                        />
                        {errors.otherSpec && <p className="text-danger">{errors.otherSpec}</p>}
                      </div>
                    )}
                  </div>
                )}



                {/* File Upload Input */}
                <div className="col-md-8 mb-3">
                  <label className="form-label">{formLanguage.attested_copy} ({language.attested_copy}) <span className="text-danger">*</span></label>
                  <p className="text-danger mb-1">{language.file_type}</p>
                  <input type="file" className="form-control" 
                  disabled={fieldDisable}
                  key={fileKey}
                  name="proof"  ref={fileInputRef} accept=".pdf, .jpeg, .jpg"  onChange={handleInputChange} />
                  {errors.proof && <p className="text-danger">{errors.proof}</p>}
                </div>

                {/* Add More Button */}
                <div className="col-md-2 d-flex align-items-end">
                  <button className="btn btn-primary w-100" type="button"
                  
                   onClick={addEducation} disabled={isLoading}>
                    {isLoading ? (
                      <i className="ion-load-a ion-spin"></i> // Loading spinner
                    ) : (
                      `+ ${language.add}`
                    )}
                  </button>
                </div>
              </div>
              <div className="d-flex align-items-start justify-content-around mb-3 flex-wrap">
      {/* Structural Engineer Select Input */}
      <div className="col-md-4 mb-3">
        <label className="form-label">
        શું તમે સ્ટ્રક્ચરલ એન્જિનિયર છો? ({language.struct_eng}){" "}
          <span className="text-danger">*</span>
        </label>
        <select
          className="form-control"
          name="isStructureEngineer"
          value={isStructuralEngineer}
          onChange={handleInputStructuredetail}
        >
           <option value="no">{language.no || "No"}</option>
          <option value="yes">{language.yes || "Yes"}</option>
         
        </select>
       {errorrs.isStructureEngineer && <div className="text-danger">{errorrs.isStructureEngineer}</div>}
      </div>

      {/* File Upload Input (Conditional) */}
     { structureDetailField != "no" &&<div className="d-flex">
      <div className="col-md-12 mb-3">
        <label className="form-label">
        સંબંધિત દસ્તાવેજ અપલોડ કરો ({language.relevant_doc}){" "}
          <span className="text-danger">*</span>
        </label>
        <p className="text-danger mb-1">{language.file_type}</p>
        <div>
        <div className="flex flex-row">

        <input
          type="file"
          className="form-control"
        name="relevantDoc"
          ref={fileInputRef}
          accept=".pdf, .jpeg, .jpg"
          disabled={structureDetailField == "no"}
          onChange={handleInputStructuredetail}
        />
         {/* {errorrs && <div className="text-danger">{errorrs.message}</div>} */}
      <p>{existData && existData.docs?.find((doc: any) => doc.documentName === "structureErrDoc")?.fileName}</p>

      {!existData?.docs?.find((doc: any) => doc.documentName === "structureErrDoc") &&
  errorrs && <div className="text-danger">{errorrs.structureDetail}</div>}
        </div>
        {/* <button className="btn btn-primary w-100" type="button"

onClick={handleUploadStructureErrdoc} disabled={isStructLoading}>
 {isStructLoading ? (
   <i className="ion-load-a ion-spin"></i> // Loading spinner
 ) : (
   <i className="fa fa-upload" data-bs-toggle="tooltip" title="Upload" />
 )}
</button> */}
        
      </div>
      <div className="col-md ">
               
      </div>
        </div>
      </div>}
     
    </div>


              {/* Display error if no education entry exists */}
              {errors.listError && educationList.length === 0 && (
                <p className="text-danger">{errors.listError}</p>
              )}

              {/* Navigation Buttons */}
              
              <div className="d-flex justify-content-between mt-3">
                <button type="button" className="btn btn-secondary me-4" onClick={onPrev}>{language.previous}</button>
                <ToastContainer position="top-center" autoClose={3000} />
               
                <button type="button" className="btn btn-primary" 
                disabled={isNextLoading}
                onClick={handleNext}>{language.next}</button>
              </div>
            </form>
          </div>
        </div>
      </div>
                  {(isNextLoading || isLoading) && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-dark bg-opacity-25"
          style={{ zIndex: 9999 }}
        >
          <div className="d-flex align-items-center px-4 py-3 bg-white rounded shadow">
            <div
              className="spinner-border text-primary me-3"
              role="status"
            />
            <span className="fw-semibold text-dark">
              {isLoading?"Uploading Details" : "Submitting..."}
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default Education;
